import { menuSeconds } from "../../constants/menu"
import HandBookComponent from "../../pages/handbook"

const handbookRoute = [
    {
      key: menuSeconds.HAND_BOOK.key,
      name: menuSeconds.HAND_BOOK.name,
      textName: menuSeconds.HAND_BOOK.textName,
      active: false,
      appBar: true,
      component: HandBookComponent
    } 
  ]
  
  export default handbookRoute